import { render, staticRenderFns } from "./HotelOffersTariffPopup.vue?vue&type=template&id=2530947e&"
import script from "./HotelOffersTariffPopup.vue?vue&type=script&lang=ts&"
export * from "./HotelOffersTariffPopup.vue?vue&type=script&lang=ts&"
import style0 from "./HotelOffersTariffPopup.vue?vue&type=style&index=0&id=2530947e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports